
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aikxuuigclviifgxpouv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFpa3h1dWlnY2x2aWlmZ3hwb3V2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDYxMzU0MTIsImV4cCI6MjA2MTcxMTQxMn0.B_QLIcI1SzziUonU0crytfBSYembVbiCmhv_g_PcU9M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL, 
  SUPABASE_PUBLISHABLE_KEY,
  {
    db: {
      schema: 'public'  // Change from 'api' to 'public' to fix the type error
    }
  }
);

// Add some error handling helpers for Supabase responses
export const isSupabaseError = <T>(data: T | any): boolean => {
  return data && typeof data === 'object' && 'code' in data && 'message' in data;
};

export const getErrorMessage = <T>(data: T | any): string => {
  if (isSupabaseError(data)) {
    return `Error ${data.code}: ${data.message}`;
  }
  return 'Unknown error occurred';
};

// Check if the result is a data object or an error object from Supabase
export const isDataResponse = <T extends object>(result: T | Error | null | undefined): result is T => {
  if (!result) return false;
  return !('error' in result) || result.error === null;
};

// Helper function to safely access object properties
export const safeGet = <T, K extends keyof T>(obj: T | null | undefined, key: K): T[K] | undefined => {
  return obj && typeof obj === 'object' && key in obj ? obj[key] : undefined;
};

// Type guard for checking if an object has specific properties
export function hasRequiredProperties<T extends object, K extends keyof T>(
  obj: unknown,
  props: K[]
): obj is T {
  if (!obj || typeof obj !== 'object') return false;
  
  return props.every(prop => 
    prop in obj && 
    // Additional check to ensure the value isn't null or undefined if needed
    (obj as any)[prop] !== null && 
    (obj as any)[prop] !== undefined
  );
}
